<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-toolbar flat dense cad>
				<v-toolbar-title class="subheading">Upload HR Policy</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-card-text>
				<v-text-field v-model="form.name" :error-messages="nameErrors" label="Policy Name" required @input="$v.form.name.$touch()" @blur="$v.form.name.$touch()"></v-text-field>

				<form enctype="multipart/form-data" novalidate class="mt-3">
					<label
						>File
						<input id="file" ref="file" type="file" accept="application/pdf" @change="handleFileUpload()" />
					</label>

					<div v-show="noFileSelectedError" class="error--text v-messages mt-1">File is required</div>
					<div class="text-xs-center mt-2" style="color: rgba(0,0,0,0.54);">
						<i>Please ensure file is in PDF format.</i>
					</div>
				</form>

				<v-alert v-if="uploadErrors != null" class="mt-3" :value="true" color="error" icon="warning" outline>
					{{ uploadErrors }}
				</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" flat @click.native="onClose()">Close</v-btn>
				<v-btn color="blue darken-1" :loading="isSaving" :disabled="isSaving" flat @click.prevent="submit()">Submit <span slot="loader">Saving...</span></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			dialog: {
				type: Boolean
			},
			uploadErrors: {},
			isSaving: {
				type: Boolean
			}
		},
		components: {},
		data() {
			return {
				uploadFileDialog: false,
				form: {
					name: null,
					file: ''
				},
				noFileSelectedError: false
			};
		},
		computed: {
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Policy Name is required.');
				return errors;
			}
		},
		methods: {
			onClose() {
				this.$emit('onClose');
			},
			submit() {
				if (this.validateForm()) {
					let formData = new FormData();
					formData.append('file', this.form.file);
					formData.append('name', this.form.name);
					this.$emit('onSubmit', formData);
				}
			},
			validateForm() {
				this.$v.form.$touch();

				let valid = true;

				if (this.$v.form.$invalid) {
					valid = false;
				}

				if (this.form.file === '') {
					valid = false;
					this.noFileSelectedError = true;
				}

				return valid;
			},
			handleFileUpload() {
				this.form.file = this.$refs.file.files[0];
				this.noFileSelectedError = false;
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				name: { required }
			}
		}
	};
</script>

<style></style>
